import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TextInputControl } from 'src/app/form-controls/text-input/text-input.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { HotCompressAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';

interface HotCompressActionFormGroup {
	area: FormControl<string | null>;
}

@Component({
    selector: 'app-hot-compress-action-controls',
    templateUrl: './hot-compress-action-controls.component.html',
    styleUrls: ['../../../common.scss', './hot-compress-action-controls.component.scss'],
    imports: [ReactiveFormsModule, TextInputControl, CommonActionControlsComponent, ActionFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HotCompressActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: HotCompressAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as HotCompressAction;
	}

	@Input() form!: FormGroup<HotCompressActionFormGroup>;
	@Input() item!: Row | null;

	constructor(private formBuilder: FormBuilder) {
	}

	ngOnInit() {
		this.form.addControl('area', this.formBuilder.control(this.action?.area ?? null));
	}
}
